import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Checkbox,
  FormGroup,
  FormControl,
  RadioGroup,
  FormControlLabel,
  TextField,
  Radio,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useDispatch, useSelector } from "react-redux";
import ApiService from "../../../functions/apiService";
import { setDashboardAbsentReason } from "../../../store/dashboardReducer";
import Error from "../../Error/Error";
import { getGridStringOperators } from "@mui/x-data-grid";
import ConfModal from "../../Modal/ConfModal";
import MyTable from "../../Schedule/MyTable";
import { toast } from 'react-toastify';

export default function EmployeeData() {
  // const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const {
    register,
    control,
    formState: { errors, isValid },
    handleSubmit,
    setError,
    setValue,
    getValues,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      Update: "Validate",
    },
  });
  let columns = [
    {
      field: "user_id",
      headerName: "ID",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "rank",
      headerName: "Name",
      flex: 1,
      minWidth: 120,
      valueGetter: (params) =>
        params.row.rank + " " + params.row.first + " " + params.row.last,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "group",
      headerName: "Group",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
  ];
  const onSubmit = (body) => {
    if (body["Value"] == false) {
      body["Value"] = [];
    }
    setLoading(true);
    ApiService.post("/employeeDataFromCsv", body)
      .then(({ data }) => {
        setLoading(false);
        console.log("data", data);
        setModalData(data);
        setOpen(true);
        toast.success('Success')
        // enqueueSnackbar("success", { variant: "success" });
      })
      .catch(({ data }) => {
        setLoading(false);
        toast.error('Error')
        // enqueueSnackbar("Error", { variant: "error" });
      });
    console.log("body", body);
  };
  const Export = () => {
    setLoading(true);
    ApiService.post("/employeeDataToCsv", {})
      .then(({ data }) => {
        setLoading(false);
        toast.success('Export Success')
        // enqueueSnackbar("Export success", { variant: "success" });
      })
      .catch(({ data }) => {
        setLoading(false);
        toast.error('Error')
        // enqueueSnackbar("Error", { variant: "error" });
      });
  };
  let closeModal = () => {
    setOpen(false);
  };
  return (
    <>
      <Typography fontWeight="700" fontSize="16px">
        {" "}
        Employee Data
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-12">
          <FormGroup row>
            <FormControlLabel
              control={<Checkbox value="Truncate" {...register("Value")} />}
              label={<Typography sx={{ fontSize: '14px' }}>Truncate db files on import</Typography>}
            />
            <FormControlLabel
              control={<Checkbox value="Delete" {...register("Value")} />}
              label={<Typography sx={{ fontSize: '14px' }}>Delete import file on import</Typography>}
            />
          </FormGroup>
          {errors.Value && <Error>{errors.Value?.message}</Error>}
        </div>
        <div className="col-12">
          <FormControl sx={{ gap: "12px" }}>
            <RadioGroup
              defaultValue={"Validate"}
              name="radio-buttons-group"
              row
            >
              <FormControlLabel
                value="Validate"
                {...register("Update", { required: "Update  is required." })}
                control={<Radio />}
                label={<Typography sx={{ fontSize: '14px' }}>Validate</Typography>}
              />
              <FormControlLabel
                value="Create"
                {...register("Update", { required: "Update  is required." })}
                control={<Radio />}
                label={<Typography sx={{ fontSize: '14px' }}>Create</Typography>}
              />
              <FormControlLabel
                value="Update"
                {...register("Update")}
                control={<Radio />}
                label={<Typography sx={{ fontSize: '14px' }}>Update</Typography>}
              />
            </RadioGroup>
          </FormControl>
          {errors.Update && <Error>{errors.Update?.message}</Error>}
        </div>
        <div className="col-12 my-2">
          <ButtonTheme
            disabled={!isValid || loading}
            color="primary"
            type="submit"
          >
            Import
          </ButtonTheme>
          <ButtonTheme
            className="mx-2"
            disabled={!isValid || loading}
            color="primary"
            type="button"
            onClick={Export}
          >
            Export
          </ButtonTheme>
        </div>
      </form>
      <ConfModal Title="Employees" open={open} closeModal={closeModal}>
        {modalData && modalData && modalData.length > 0 && (
          <div>
            <MyTable
              rows={modalData}
              columns={columns}
              useTopFilter={false}
              checkboxSelection={false}
              hideFooter={true}
            />
          </div>
        )}
      </ConfModal>
    </>
  );
}
